import "./AuthFormWrapper.scss";
import React from "react";
import lenditLogo from "assets/Lendit-logo.png";
import { ToastContainer } from "react-toastify";

interface IAuthFormWrapperProps {
  children: React.ReactNode;
}

export const AuthFormWrapper = ({ children }: IAuthFormWrapperProps) => {
  return (
    <div className="general-container-auth">
      <div className="elements">
        <img src={lenditLogo} className="form-logo" alt="form-logo-image" />
        <div className="form-container">
          {children}
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};
